export default {
  namespaced: true,
  state: {
    drawer: false,
    profileSettingsDrawer: false,
    theme: false
  },
  mutations: {
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    toggleProfileSettingsDrawer(state) {
      state.profileSettingsDrawer = !state.profileSettingsDrawer
    },
    toggleTheme(state) {
      state.theme = !state.theme;
    },
  },
  actions: {
    TOGGLE_DRAWER({commit}) {
      commit('toggleDrawer');
    },
    TOGGLE_PROFILE_SETTINGS_DRAWER({commit}) {
      commit('toggleProfileSettingsDrawer');
    },
    TOGGLE_THEME({commit}) {
      commit('toggleTheme');
    },
  },
  getters: {
    DRAWER_STATE(state) {
      return state.drawer;
    },
    PROFILE_SETTINGS_DRAWER_STATE(state) {
      return state.drawer;
    },
    THEME_STATE(state) {
      return state.theme;
    },
  },
}
